export default "__VITE_ASSET__51bLtv$U__"